import './App.less';
import {Index} from "./Pages";

const App = () => (
  <Index />
)

export default App;
